import { ajaxJson } from 'imports/ajax';
import { map2EnrollmentResult } from 'imports/mapper';
import { createTypes } from 'redux-create-types';


const namespace = 'page-enrollment-receipt';

export const enrollmentReceiptPageActions = createTypes([
    'toggleSpinner',
    'setError',
    'setReceipt'
], namespace);

function showSpinner(apiName) {
    return dispatch => {
        dispatch({
            type: enrollmentReceiptPageActions.toggleSpinner,
            payload: true,
            meta: {apiName}
        });
    }
}

function hideSpinner(apiName) {
    return dispatch => {
        dispatch({
            type: enrollmentReceiptPageActions.toggleSpinner,
            payload: false,
            meta: {apiName}
        });
    }
}

function getReceiptApiSuccess(res) {
    return dispatch => {
        const resultObj = map2EnrollmentResult(res.data);
        return dispatch({
            type: enrollmentReceiptPageActions.setReceipt,
            payload: resultObj
        });
    }
}

function getReceiptApiFail(err) {
    return dispatch => {
        dispatch({
            type: enrollmentReceiptPageActions.setError,
            payload: err,
        })
        return dispatch(hideSpinner('receipt'));
    }
}

function getReceiptFromApi(id) {
    return dispatch => {
        dispatch(showSpinner('receipt'));
        return ajaxJson.get(`/programs/enrollments/${id}`)
        .then(
            res => dispatch(getReceiptApiSuccess(res)),
            err => dispatch(getReceiptApiFail(err)),
        ).then(() => {
            return dispatch(hideSpinner('receipt'));
        })
    }
}

export const enrollmentReceiptPageActionsCreators = {
    getReceiptFromApi,
}